
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions-pro",
      function () {
        return require("private-next-pages/solutions-pro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions-pro"])
      });
    }
  